import { OmniChannelMessageComposition } from '@interhyp/module-communication';
import { CenterLayout } from '@interhyp/platform-layout';
import React from 'react';

function PageStart() {
  return (
    <CenterLayout>
      <OmniChannelMessageComposition />
    </CenterLayout>
  );
}

export { PageStart };
